import { FC, useRef } from 'react'

import * as S from './styled'
import {
  ArcPlusIcon,
  ArrowRightIcon,
  AwardIcon,
  BenefitsShape,
  BookShape,
  BurstIcon,
  CalendarRoundIcon,
  CameraIcon,
  CardListIcon,
  CardShape,
  CartIcon,
  ChatBubbleIcon,
  CloseCircleIcon,
  CoinIcon,
  DatabaseIcon,
  DeliveryIcon,
  DeviceIcon,
  DividerWithStars,
  DocumentIcon,
  FruitsIcon,
  GiftRoundIcon,
  IdCardIcon,
  MegaphoneIcon,
  MixedFruitsIcon,
  PaymentIcon,
  PercentIcon,
  ProfileIcon,
  RefreshIcon,
  SendIcon,
  ShopIcon,
  StarIcon,
  StarsShape,
  TicketIcon,
  TrophyIcon,
  TruckIcon,
  UserIcon,
  WalletIcon
} from '../../icons'
import GiftPrimaryIcon from '../../icons/GiftPrimaryIcon'

const Benefits: FC = () => {
  function ExpirationTable() {
    const scrollerRef = useRef<HTMLDivElement>(null)

    const scroll = (dir: 'left' | 'right') => {
      const el = scrollerRef.current

      if (!el) {
        return
      }

      const amount = Math.max(200, Math.floor(el.clientWidth * 0.9))

      el.scrollBy({
        left: dir === 'left' ? -amount : amount,
        behavior: 'smooth'
      })
    }

    const expirations = [
      { month: 'Janeiro', expire: '01/mai' },
      { month: 'Fevereiro', expire: '01/jun' },
      { month: 'Março', expire: '01/jul' },
      { month: 'Abril', expire: '01/ago' },
      { month: 'Maio', expire: '01/set' },
      { month: 'Junho', expire: '01/out' },
      { month: 'Julho', expire: '01/nov' },
      { month: 'Agosto', expire: '01/dez' },
      { month: 'Setembro', expire: '01/jan' },
      { month: 'Outubro', expire: '01/fev' },
      { month: 'Novembro', expire: '01/mar' },
      { month: 'Dezembro', expire: '01/abr' }
    ]

    return (
      <S.TableWrapper>
        <S.Arrow onClick={() => scroll('left')} aria-label="Anterior">
          <span>‹</span>
        </S.Arrow>

        <S.TableExpirationRow ref={scrollerRef}>
          <S.TableExpirationColumn>
            <S.TableExpirationLabel>
              <strong>Mês de acúmulo</strong>
            </S.TableExpirationLabel>
            <S.TableExpirationValuel>
              <strong>Data de expiração</strong>
            </S.TableExpirationValuel>
          </S.TableExpirationColumn>

          {expirations.map(expiration => (
            <S.TableExpirationColumn key={expiration.month}>
              <S.TableExpirationLabel>
                {expiration.month}
              </S.TableExpirationLabel>
              <S.TableExpirationValuel>
                {expiration.expire}
              </S.TableExpirationValuel>
            </S.TableExpirationColumn>
          ))}
        </S.TableExpirationRow>

        <S.ArrowRight onClick={() => scroll('right')} aria-label="Próximo">
          <span>›</span>
        </S.ArrowRight>

        <S.FadeLeft />
        <S.FadeRight />
      </S.TableWrapper>
    )
  }

  const benefits = [
    'O Programa de Fidelidade disponibiliza descontos em porcentagem exclusivos para participantes do Programa de Fidelidade.',
    'Os descontos podem ser ativados, sem a utilização de pontos, e utilizados mediante a identificação da compra com o CPF.',
    'Os descontos não são válidos em produtos promocionais e na contratação de serviços de instalação e reforma.',
    'A validade e as condições estão determinadas nos cupons de desconto, dentro da aba “Minhas Vantagens”. O cupom não é cumulativo com outros descontos.'
  ]

  const cashbacks = [
    'Se o valor da compra for maior que o saldo do cashback, o Participante poderá pagar a diferença com outros meios de pagamento.',
    'O cashback deve ser usado integralmente (não é permitido usar apenas uma parte).',
    'É possível usar mais de um cashback na mesma compra, desde que as regras sejam seguidas.'
  ]

  const conditions = [
    'O cashback deve ser utilizado de maneira integral na LEROY MERLIN, em compra com o valor mínimo igual ou superior ao cashback recebido.',
    'O CPF deve ser informado no momento da compra para o reconhecimento do benefício.',
    'Caso não utilizado no mês subsequente, o cashback perderá a validade.'
  ]

  return (
    <S.Wrapper>
      <S.Container>
        <S.Wrapper>
          <S.Content>
            <S.Title>
              <span>04</span> Benefícios
            </S.Title>

            <S.RowTextIntro>
              <p>
                Os benefícios concedidos no Programa de Fidelidade são
                exclusivos e direcionados a cada Participante e, os seus pontos
                não podem ser transferidos, doados, comprados ou trocados.
              </p>

              <p>
                O uso dos pontos depende da comunicação entre a LEROY MERLIN e
                os Participantes que receberão comunicações através do e-mail,
                SMS, WhatsApp, notificação no aplicativo e no computador.
              </p>

              <p>
                A LEROY MERLIN poderá excluir os pontos atribuídos de forma
                indevida que descumprirem os Termos e Condições, por erro
                técnico ou fraude.
              </p>

              <BenefitsShape />
            </S.RowTextIntro>

            <S.Subtitle>Acúmulo de pontos</S.Subtitle>

            <S.RowScore>
              <S.ScoreTitle>
                <div>Pontuação</div>

                <StarsShape />
              </S.ScoreTitle>

              <S.ScoreInfo>
                <h3>Somente Cliente e EAD</h3>

                <p>
                  Para compensar a fidelidade dos participantes das categorias
                  Consumidor Final e EAD, a LEROY MERLIN oferece um sistema de
                  benefícios financeiros com acúmulo de pontos pela compra de
                  produtos na LEROY MERLIN em nossas lojas físicas, site, app e
                  televendas, para serem usados depois no resgate de cashback em
                  pontos.
                </p>

                <S.ScoreIcons>
                  <SendIcon />

                  <UserIcon width="43" height="43" />
                </S.ScoreIcons>
              </S.ScoreInfo>
            </S.RowScore>

            <S.RowConditions>
              <S.ConditionsTitle>
                O Cliente deve cumprir as seguintes condições:
              </S.ConditionsTitle>

              <S.ConditionsObligation>
                <DeviceIcon />

                <span>Cadastrar-se no Programa de Fidelidade</span>
              </S.ConditionsObligation>

              <S.ConditionsObligation>
                <ProfileIcon />
                <span>Informar o número de seu CPF na compra</span>
              </S.ConditionsObligation>
            </S.RowConditions>

            <S.RowExample>
              <S.ExampleInfo>
                <h3>Como funciona?</h3>

                <S.ExampleInfoRow>
                  <p>
                    Cada real gera um ponto, sendo desconsiderados os centavos
                    no cálculo.
                  </p>

                  <S.ExampleFigure>R$1,00 = 1 ponto</S.ExampleFigure>
                </S.ExampleInfoRow>
              </S.ExampleInfo>

              <S.ExampleExceptions>
                <h4>A pontuação não é válida para os valores de:</h4>

                <ul>
                  <li>
                    <TruckIcon />

                    <span>
                      Frete e garantia
                      <br />
                      estendida.
                    </span>
                  </li>
                  <li>
                    <PaymentIcon />

                    <span>
                      Cashback do Programa de
                      <br />
                      Fidelidade,
                    </span>
                  </li>
                  <li>
                    <TicketIcon />

                    <span>Vales-trocas</span>
                  </li>
                  <li>
                    <GiftRoundIcon />

                    <span>Cartão de presente</span>
                  </li>
                </ul>
              </S.ExampleExceptions>
            </S.RowExample>

            <S.DeadlineRow>
              <h3>Prazo</h3>

              <p>
                O acúmulo de pontos, realizado a partir de 01/01/2024, é
                atribuído ao perfil do Participante em até 10 (dez) dias após a
                realização da Compra.
              </p>
            </S.DeadlineRow>

            <S.TableExpiration>
              <h4>Veja abaixo o período de validade do acúmulo de pontos:</h4>

              {ExpirationTable()}

              <p>
                A LEROY MERLIN poderá atribuir pontos-bônus ao participante em
                casos de promoções especiais por data comemorativa, um
                fabricante específico ou uma linha de produtos, por exemplo.
              </p>
            </S.TableExpiration>

            <S.RowExtraScore>
              <S.ExtraScoreTitle>
                <div>Pontuação extra</div>
                <CardShape />
              </S.ExtraScoreTitle>

              <S.ExtraScoreInfo>
                <h3>Cartão Celebre! Elo</h3>

                <p>
                  Ao aderir o Cartão Celebre! Elo, o Participante poderá
                  aproveitar campanhas, aceleradores e bonificações
                  extraordinários de pontos no Programa de Fidelidade.
                </p>

                <p>
                  Essas vantagens estão disponíveis aos cartões{' '}
                  <strong>Mais</strong>, <strong>Grafite</strong>,
                  <strong>Nanquim</strong> e <strong>Pro</strong>.
                </p>

                <p>
                  A LEROY MERLIN irá divulgar as ofertas, regras e prazos no
                  site ou por meio de comunicações oficiais
                </p>

                <S.ScoreIcons>
                  <CardListIcon />
                </S.ScoreIcons>
              </S.ExtraScoreInfo>
            </S.RowExtraScore>

            <S.PointConditions>
              <h4>As pontuações extras só serão concedidas se</h4>

              <S.PointConditionsRow>
                <S.PointConditionsColumn>
                  <span>A</span>
                  <p>Você estiver com o pagamento do cartão em dia.</p>
                </S.PointConditionsColumn>
                <S.PointConditionsColumn>
                  <span>B</span>
                  <p>
                    Cumprir as condições do contrato do Cartão Celebre! Elo.
                  </p>
                </S.PointConditionsColumn>
              </S.PointConditionsRow>
            </S.PointConditions>

            <S.PointRescue>
              <h4>Acesso e resgate dos pontos</h4>

              <DividerWithStars />

              <S.PointRescueRow>
                <S.PointRescueColumn>
                  <strong>1</strong>
                  <p>Cadastre-se no Programa de Fidelidade</p>
                </S.PointRescueColumn>
                <S.PointRescueColumn>
                  <strong>2</strong>
                  <p>Pague suas compras com o Cartão Celebre! Elo</p>
                </S.PointRescueColumn>
                <S.PointRescueColumn>
                  <strong>3</strong>
                  <p>Serão acumulados pontos extras com base no valor gasto</p>
                </S.PointRescueColumn>
              </S.PointRescueRow>
            </S.PointRescue>

            <S.CardRow>
              <S.CardColumn>
                <S.CardImage>
                  <img
                    src={`${window.env.assetHost}assets/images/lmcv/program-rules/cartao-celebre-elo-mais.png`}
                    alt="Cartão Celebre Elo Mais"
                  />
                </S.CardImage>

                <div>
                  <h3>Cartão Celebre! Elo Mais</h3>

                  <ul>
                    <li>
                      <BurstIcon />
                      <span>1 ponto Extra</span>
                    </li>
                    <li>
                      <DatabaseIcon />
                      <span>A cada R$ 5,00 gastos</span>
                    </li>
                  </ul>
                </div>
              </S.CardColumn>
              <S.CardColumn>
                <S.CardImage>
                  <img
                    src={`${window.env.assetHost}assets/images/lmcv/program-rules/cartao-celebre-elo-grafite.png`}
                    alt="Cartão Celebre Elo Grafite"
                  />
                </S.CardImage>

                <div>
                  <h3>Cartão Celebre! Elo Grafite</h3>

                  <ul>
                    <li>
                      <BurstIcon />
                      <span>1 ponto Extra</span>
                    </li>
                    <li>
                      <DatabaseIcon />
                      <span>A cada R$ 4,00 gastos</span>
                    </li>
                  </ul>
                </div>
              </S.CardColumn>
            </S.CardRow>
            <S.CardRow>
              <S.CardColumn>
                <S.CardImage>
                  <img
                    src={`${window.env.assetHost}assets/images/lmcv/program-rules/cartao-celebre-elo-nanquim.png`}
                    alt="Cartão Celebre Elo Nanquim"
                  />
                </S.CardImage>

                <div>
                  <h3>Cartão Celebre! Elo Nanquim</h3>

                  <ul>
                    <li>
                      <BurstIcon />
                      <span>1 ponto Extra</span>
                    </li>
                    <li>
                      <DatabaseIcon />
                      <span>A cada R$ 2,00 gastos</span>
                    </li>
                  </ul>
                </div>
              </S.CardColumn>
              <S.CardColumn>
                <S.CardImage>
                  <img
                    src={`${window.env.assetHost}assets/images/lmcv/program-rules/cartao-celebre-pro.png`}
                    alt="Cartão Celebre Pro"
                  />
                </S.CardImage>

                <div>
                  <h3>Cartão Pro</h3>

                  <ul>
                    <li>
                      <BurstIcon />
                      <span>1 ponto Extra</span>
                    </li>
                    <li>
                      <DatabaseIcon />
                      <span>A cada R$ 5,00 gastos</span>
                    </li>
                  </ul>
                </div>
              </S.CardColumn>
            </S.CardRow>

            <S.LegendRow>
              <S.LegendColumn>
                <h3>Prazos</h3>
                <p>
                  O acúmulo de pontos, realizado a partir de 23/10/2023, será
                  atribuído ao perfil do Participante em{' '}
                  <strong>
                    até 60 (sessenta) dias após a realização da compra
                  </strong>
                  .
                </p>
              </S.LegendColumn>

              <S.LegendColumn>
                <h3>Recusa, suspensão e cancelamento</h3>
                <p>
                  A LEROY MERLIN poderá alterar ou encerrar a bonificação de
                  pontos, a qualquer momento, com aviso prévio de{' '}
                  <strong>
                    60 (sessenta) dias de antecedência aos membros e com período
                    de 30 (trinta) dias para resgate
                  </strong>
                  .
                </p>
              </S.LegendColumn>
            </S.LegendRow>

            <S.BlockRow>
              <h3>
                A LEROY MERLIN poderá suspender e/ou cancelar contas de membros
                se:
              </h3>

              <S.BlockInnerRow>
                <S.BlockInnerColumn>
                  <span>A</span>
                  <p>
                    Os membros forem suspeitos de abusos, fraudes e/ou violação
                    dos termos e condições deste regulamento, resultando na
                    perda de todos os pontos acumulados.
                  </p>
                </S.BlockInnerColumn>

                <S.BlockInnerColumn>
                  <span>B</span>
                  <p>
                    O Cartão Celebre!Elo for cancelado. A LEROY MERLIN poderá
                    suspender e/ou cancelar a pontuação no período de 30 dias,
                    de forma voluntária ou não.
                  </p>
                </S.BlockInnerColumn>
              </S.BlockInnerRow>
            </S.BlockRow>

            <S.PointsRedemption>
              <S.PointsRedemptionRow>
                <S.PointsRedemptionTitle>
                  Resgate de Pontos
                </S.PointsRedemptionTitle>

                <S.PointsRedemptionRescue>
                  <h4>Resgate</h4>

                  <p>
                    O Participante pode trocar seus pontos por Cashback para
                    usar em compras na LEROY MERLIN. O Cashback poderá ser
                    utilizado como método de pagamento em qualquer canal de
                    venda: loja física, site ou app
                  </p>
                </S.PointsRedemptionRescue>

                <h4>Condições</h4>

                <ShopIcon />

                <p>
                  É necessário ter uma quantidade mínima de pontos para fazer o
                  resgate. Você pode conferir essa informação na aba
                  &quot;Troque&quot; do Programa de Fidelidade, no site ou no
                  app.
                </p>
              </S.PointsRedemptionRow>

              <S.PointsRedemptionBg>
                <BookShape />
              </S.PointsRedemptionBg>
            </S.PointsRedemption>

            <S.RescueMoreInfo>
              <S.RescueMoreInfoColumn>
                <CalendarRoundIcon />

                <p>
                  Ao resgatar, os pontos que estão mais próximos de vencer serão
                  usados primeiro. Os pontos mais recentes serão preservados.
                </p>
              </S.RescueMoreInfoColumn>
              <S.RescueMoreInfoColumn>
                <CartIcon />

                <p>
                  O cashback será aplicado automaticamente na sua próxima
                  compra, desde que você informe seu CPF na hora do pagamento.
                </p>
              </S.RescueMoreInfoColumn>
            </S.RescueMoreInfo>
          </S.Content>
        </S.Wrapper>
      </S.Container>
      <S.FullInfo>
        <S.CenterInfo>
          <p>
            A LEROY MERLIN pode, de vez em quando, oferecer promoções especiais
            para resgatar cashback com menos pontos. Fique de olho em nossas
            comunicações. Se você não recebe nossas comunicações, ative a
            permissão de envio.
          </p>

          <TrophyIcon />
        </S.CenterInfo>
      </S.FullInfo>
      <S.Center>
        <S.Cashback>
          <h2>Cashback</h2>

          <S.CashbackRow>
            <S.CashbackColumn1>
              <h3>Validade do Cashback</h3>
            </S.CashbackColumn1>

            <S.CashbackColumn2>
              <S.CashbackLine>
                <CalendarRoundIcon />

                <p>
                  Após a troca dos pontos, o cashback é válido por 30 dias a
                  partir da data do resgate.
                </p>
              </S.CashbackLine>
              <S.CashbackLine>
                <WalletIcon />

                <p>
                  Ele pode ser usado apenas para compras na LEROY MERLIN (não
                  vale para o marketplace).
                </p>
              </S.CashbackLine>
            </S.CashbackColumn2>

            <S.CashbackColumn3>
              <CloseCircleIcon />

              <p>Após a validade, o cashback não poderá mais ser utilizado.</p>
            </S.CashbackColumn3>
          </S.CashbackRow>

          <S.HowToUseCashback>Como usar o cashback?</S.HowToUseCashback>

          <S.HowToUseCashbackRow>
            <S.HowToUseCashbackColumn1>
              <AwardIcon />

              <p>
                Faça uma compra com valor no mínimo R$ 0,01 maior que o saldo do
                cashback.
              </p>
            </S.HowToUseCashbackColumn1>
            <S.HowToUseCashbackColumn2>
              <IdCardIcon />

              <p>Identifique a compra com o seu CPF.</p>
            </S.HowToUseCashbackColumn2>

            <S.HowToUseCashbackColumn3>
              <ChatBubbleIcon />

              <p>Avise no caixa que quer usar o cashback no pagamento.</p>
            </S.HowToUseCashbackColumn3>
          </S.HowToUseCashbackRow>

          <S.CashbackList>
            <ul>
              {cashbacks.map(cashback => (
                <li key={cashback}>
                  <ArrowRightIcon />

                  <span>{cashback}</span>
                </li>
              ))}
            </ul>
          </S.CashbackList>
        </S.Cashback>

        <S.RowCashbackArc>
          <S.RowCashbackArcColumnLabel>
            <ArcPlusIcon />

            <h3>
              <strong>Cashback ARC+</strong>
              <span>para Arquitetos</span>
            </h3>
          </S.RowCashbackArcColumnLabel>
          <S.RowCashbackArcColumnValue>
            <S.RowCashbackArcRow>
              <S.RowCashbackArcReceipt>
                <h3>Recebimento do cashback</h3>
                <p>Se a nota fiscal for enviada:</p>

                <S.RowCashbackArcReceiptRow>
                  <S.RowCashbackArcReceiptColumn>
                    <CalendarRoundIcon />

                    <h3>Até o dia 20 do mês corrente</h3>
                    <p>O cashback é recebido até o dia 5 do mês seguinte</p>
                  </S.RowCashbackArcReceiptColumn>
                  <S.RowCashbackArcReceiptColumn>
                    <DocumentIcon />
                    <h3>Data de pagamento</h3>
                    <p>
                      após 15 dias da data emissão da nota fiscal enviada no mês
                      corrente.
                    </p>
                  </S.RowCashbackArcReceiptColumn>
                </S.RowCashbackArcReceiptRow>
              </S.RowCashbackArcReceipt>

              <S.RowCashbackArcAlert>
                <MegaphoneIcon />
                <S.RowCashbackArcAlertRowColumn>
                  <h3>Atenção!</h3>
                  <p>
                    As notas emitidas entre os dias 21 e 30 não serão aceitas.
                  </p>
                </S.RowCashbackArcAlertRowColumn>
              </S.RowCashbackArcAlert>
            </S.RowCashbackArcRow>
          </S.RowCashbackArcColumnValue>
        </S.RowCashbackArc>

        <S.RowCashbackArc>
          <S.RowCashbackArcColumnLabel>
            <h3>
              <span>Clientes do</span>
              <strong>segmento PRO</strong>
            </h3>
            <p>
              O cashback é recebido de acordo com o volume de compras do mês
              anterior.
            </p>
          </S.RowCashbackArcColumnLabel>
          <S.RowCashbackArcColumnValue>
            <S.RowCashbackArcMonthPro>
              <h3>Resgate de Cashback Mensal PRO</h3>

              <p>
                Os profissionais do segmento PRO recebem cashback mensais para
                uso na LEROY MERLIN, calculado por meio de percentual do valor
                de suas compras, realizadas no mês anterior, da seguinte forma:
              </p>

              <table>
                <thead>
                  <tr>
                    <td>
                      <S.RowCashbackArcMonthProHead>
                        <CameraIcon />
                        Valor de compra no mês
                      </S.RowCashbackArcMonthProHead>
                    </td>
                    <td>
                      <S.RowCashbackArcMonthProHead>
                        <PercentIcon />
                        Percentual de cashback
                      </S.RowCashbackArcMonthProHead>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span>Abaixo de R$ 1.000,00</span>
                    </td>
                    <td>
                      <strong>Não haverá cashback</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>Entre R$ 1.000,00 e R$ 2.499,00</span>
                    </td>
                    <td>5%</td>
                  </tr>
                  <tr>
                    <td>
                      <span>Entre R$ 2.500,00 e 4.999,00</span>
                    </td>
                    <td>8%</td>
                  </tr>
                  <tr>
                    <td>
                      <span>Compra igual ou acima de R$ 5.000,00</span>
                    </td>
                    <td>10%</td>
                  </tr>
                </tbody>
              </table>
            </S.RowCashbackArcMonthPro>
          </S.RowCashbackArcColumnValue>
        </S.RowCashbackArc>

        <S.CashbackDetailsRow>
          <S.CashbackDetailsColumn>
            <h3>Prazos</h3>

            <p>
              O cashback mensal das compras realizadas no mês anterior, será
              ativado automaticamente na conta do usuário e poderá ser utilizado{' '}
              <strong>até o último dia do mês de recebimento</strong>.
            </p>
          </S.CashbackDetailsColumn>
          <S.CashbackDetailsColumn>
            <h3>Condições</h3>

            <ul>
              {conditions.map(condition => (
                <li key={condition}>
                  <ArrowRightIcon />
                  <span>{condition}</span>
                </li>
              ))}
            </ul>
          </S.CashbackDetailsColumn>
        </S.CashbackDetailsRow>

        <S.CashbackProExceptions>
          <h3>O cashback mensal PRO não é válido para:</h3>

          <ul>
            <li>
              <DeliveryIcon />
              Frete;
            </li>
            <li>
              <StarIcon />
              Garantia estendida;
            </li>
            <li>
              <CoinIcon />
              Cashback em pontos do LMCV;
            </li>
            <li>
              <RefreshIcon />
              Vale troca;
            </li>
            <li>
              <GiftPrimaryIcon />
              Cartão presente.
            </li>
          </ul>
        </S.CashbackProExceptions>

        <S.CashbackProducts>
          <h2>Produtos</h2>

          <ul>
            <li>Toda a família de Cimentos (todos os códigos possíveis);</li>

            <li>
              Todos os produtos com desconto ou qualquer código promocional;
            </li>

            <li>
              Produtos adquiridos no Marketplace, que sejam comercializados por
              terceiros.
            </li>
          </ul>
        </S.CashbackProducts>

        <S.FooterBenefits>
          <S.FooterBenefitsBgTop>
            <FruitsIcon />
          </S.FooterBenefitsBgTop>
          <S.FooterBenefitsBgBottom>
            <MixedFruitsIcon />
          </S.FooterBenefitsBgBottom>
          <S.FooterBenefitsColumn1>
            <h3>Descontos em porcentagem</h3>
            <ul>
              {benefits.map(benefit => (
                <li key={benefit}>
                  <ArrowRightIcon />
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>
          </S.FooterBenefitsColumn1>

          <S.FooterBenefitsColumn2>
            <h3>Outros benefícios</h3>
            <p>
              Os benefícios incluem o envio automático e gratuito de conteúdo
              direcionado (como vídeos, textos, guias e manuais), promoção de
              ofertas relâmpagos em pontos de venda, pontos em dobro para algum
              produto ou forma de pagamento, entre outros.
            </p>
            <p>
              A concessão dos benefícios ocorre por exclusivo critério da LEROY
              MERLIN.
            </p>
          </S.FooterBenefitsColumn2>
        </S.FooterBenefits>
      </S.Center>
    </S.Wrapper>
  )
}

export default Benefits
